import React, { useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { history } from 'nallian-shared-ui/lib/config/history';
import OrganisationForm from './OrganisationForm';
import organisationService from '../services/organisationService';
import { TABS } from '../constants';

const EditOrganisation = ({
  dispatchOrganisationGet,
  dispatchUpdateOrganisationPut,
  updateOrganisationFetch,
  organisationFetch,
}) => {
  const { id } = useParams();

  useEffect(() => dispatchOrganisationGet(id), [dispatchOrganisationGet, id]);

  const initialValues = useMemo(
    () =>
      organisationFetch.value && {
        ...organisationFetch.value,
        countryCode: String(organisationFetch.value.countryCode).toUpperCase(),
      },
    [organisationFetch.value]
  );

  const handleSubmit = useCallback(
    values => {
      dispatchUpdateOrganisationPut(id, values, () => {
        history.push(`/organisations/${id}/${TABS.DETAILS}`);
      });
    },
    [dispatchUpdateOrganisationPut, id]
  );

  return (
    <OrganisationForm
      editMode
      initialValues={initialValues}
      processingForm={!!updateOrganisationFetch.pending}
      onSubmitForm={handleSubmit}
      pageTitle={`Edit organisation ${
        organisationFetch.fulfilled ? organisationFetch.value.organisationName : '...'
      }`}
      loadingContent={!!organisationFetch.pending}
    />
  );
};

EditOrganisation.propTypes = {
  dispatchUpdateOrganisationPut: PropTypes.func.isRequired,
  dispatchOrganisationGet: PropTypes.func.isRequired,
  updateOrganisationFetch: PropTypes.object.isRequired,
  organisationFetch: PropTypes.object.isRequired,
};

export default organisationService(EditOrganisation);
